const STORAGE_KEY = "kia_lead_submissions";

const todayStr = () => new Date().toDateString();

const normalizeMobile = (mobile) => String(mobile || "").replace(/\D/g, "").slice(-10);

const readStore = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
};

// True if this mobile number already submitted any form today.
export const hasSubmittedToday = (mobile) => {
  const num = normalizeMobile(mobile);
  if (num.length !== 10) return false;
  return readStore()[num] === todayStr();
};

export const markSubmittedToday = (mobile) => {
  const num = normalizeMobile(mobile);
  if (num.length !== 10) return;
  const store = readStore();
  store[num] = todayStr();
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    // ignore quota errors
  }
};

export const DUPLICATE_LEAD_MESSAGE =
  "You've already submitted a request today with this mobile number. Our team will contact you soon.";
